import React, { useState , useEffect } from 'react';
import './Contact.scss';
import { NavLink, useNavigate } from 'react-router-dom';


const ContactHeader = () =>  {


    const navigate = useNavigate()

    const [menuToggle , setMenuToggle] = useState(false);

    const handleRightMenu = () => {
      setMenuToggle(!menuToggle)
    }
  
    const [mouseEvent , setMouseEvent] = useState('');
  
    const handleMouseState = (link) => {
      setMouseEvent(link)
    }
    
  
    useEffect(() => {
      // Define the positions for each link
      const positionMap = {
        'link1': '7%',
        'link2': '38%',
        'link3': '74%',
        "" : '-30%'
      };
  
      // Set the position of .dot-romer based on the mouseEvent
      const dotRomer = document.querySelector('.dot-romer');
      if (dotRomer && positionMap[mouseEvent]) {
        dotRomer.style.left = positionMap[mouseEvent];
      }
    }, [mouseEvent]);
  

    
  return (
    <div className="ContactHeader">
      <div className={`header-section-inner bg-white relative py-4 border-b`}>
        <div className="container">
          <div className="header-strip flex items-center justify-between">
            <button type='button' className="header-logo flex items-center gap-4" onClick={() => navigate('/')}>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 174 200" fill="none">
                <path d="M157.688 58.9623L173.211 49.997L86.6054 0L0 49.997V150.003L86.6054 200L173.211 150.003V97.0175L86.6054 47.0205L40.7234 73.5132V82.5971L103.943 119.099V124.921L86.6054 135.061L40.7234 108.568V126.487L86.6054 152.98L132.487 126.487V117.403L64.1091 77.9247L86.6054 64.9392L157.688 105.971V141.038L86.6054 182.069L15.5233 141.038V58.9623L86.6054 17.9306L157.688 58.9623Z" fill="#080808"/>
              </svg>
              <h2 className=' text-homeblack font-semibold relative font-Inter text-2xl'>SG CODES <span></span></h2>
            </button>
            <div className="header-navigation">
              <nav className='flex items-center gap-12 relative overflow-hidden'>
                  <ul className='flex items-center gap-10 px-6 py-3'>
                    <li><NavLink className='text-homeblack relative font-Manrope text-base duration-300' onMouseEnter={() => handleMouseState('link1')} onMouseLeave={() => handleMouseState('')} to={'/'}>Home</NavLink></li>
                    <li><NavLink className=' relative font-Manrope text-base duration-300' onMouseEnter={() => handleMouseState('link2')} onMouseLeave={() => handleMouseState('')}  to={'/About-Me'}>About Me</NavLink></li>
                    <li><NavLink className='text-homeblack relative font-Manrope text-base duration-300' onMouseEnter={() => handleMouseState('link3')} onMouseLeave={() => handleMouseState('')} to={'/Contact-Me'}>Contact</NavLink></li>
                  </ul>
                  <div className="dot-romer w-[50px] h-[2px] rounded-full bg-red-400 absolute bottom-2 left-[8%] duration-300 ease-in-out">

                  </div>               
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ContactHeader.propTypes = {};

ContactHeader.defaultProps = {};

export default ContactHeader;
